export default {
    apiKey: "AIzaSyDVlYO5m31S70kSnMAShDgboThHaZ3THCQ",
    authDomain: "portfolio-admin-6750a.firebaseapp.com",
    projectId: "portfolio-admin-6750a",
    storageBucket: "portfolio-admin-6750a.appspot.com",
    databaseURL: "https://portfolio-admin-6750a-default-rtdb.firebaseio.com",
    messagingSenderId: "16897334939",
    appId: "1:16897334939:web:549fb1f624d9eb31ddf03e",
    measurementId: "G-CN4G224J2B"
};